import React from "react";
import "../styles/footer-studio.css";
import {
  STUDIO_ADDRESS,
  STUDIO_MAP_URL,
  STUDIO_PHONE,
  STUDIO_PHONE_DISPLAY,
  WHATSAPP_BOOKING_URL,
} from "../utils/contactDetails";

const socialLinks = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=100090420534325&mibextid=ZbWKwL",
    icon: "fab fa-facebook-f",
  },
  {
    label: "Instagram",
    href: "https://instagram.com/arpitaamanna72?igshid=NmQ2ZmYxZjA=",
    icon: "fab fa-instagram",
  },
];

const quickLinks = [
  { label: "Home", href: "/" },
  { label: "About the studio", href: "/#about" },
  { label: "Portfolio", href: "/#portfolio" },
  { label: "Customer reviews", href: "/#reviews" },
  { label: "Rate chart", href: "/rate-chart" },
];

export default function Footer() {
  return (
    <footer className="footer-studio" id="site-footer">
      <div className="footer-studio__ornament" aria-hidden="true" />
      <div className="footer-studio__container">
        <div className="footer-studio__main">
          <div className="footer-studio__brand">
            <a className="footer-studio__wordmark" href="/" aria-label="Arpita's Makeover home">
              <span className="footer-studio__brand-icon" aria-hidden="true">
                <i className="fas fa-magic" />
              </span>
              <span>Arpita’s <strong>Makeover</strong></span>
            </a>
            <p className="footer-studio__tagline">Feel the magic touch.</p>
            <p className="footer-studio__description">
              Thoughtful makeup and styling for the moments you want to remember.
            </p>
            <a
              className="footer-studio__book"
              href={WHATSAPP_BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Book an appointment on WhatsApp"
            >
              Book an appointment
              <i className="fab fa-whatsapp" aria-hidden="true" />
            </a>
          </div>

          <nav className="footer-studio__links" aria-label="Footer navigation">
            <h2>Explore</h2>
            {quickLinks.map((link) => (
              <a href={link.href} key={link.label}>{link.label}</a>
            ))}
          </nav>

          <section className="footer-studio__contact" aria-labelledby="footer-contact-heading">
            <h2 id="footer-contact-heading">Contact</h2>
            <a
              className="footer-studio__contact-item"
              href={STUDIO_MAP_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="footer-studio__contact-icon" aria-hidden="true">
                <i className="fas fa-map-marker-alt" />
              </span>
              <span className="footer-studio__contact-copy">
                <small>Studio address</small>
                <strong>{STUDIO_ADDRESS}</strong>
              </span>
              <i className="fas fa-external-link-alt footer-studio__contact-external" aria-hidden="true" />
            </a>
            <a className="footer-studio__contact-item" href={`tel:${STUDIO_PHONE}`}>
              <span className="footer-studio__contact-icon" aria-hidden="true">
                <i className="fas fa-phone-alt" />
              </span>
              <span className="footer-studio__contact-copy">
                <small>Call the studio</small>
                <strong>{STUDIO_PHONE_DISPLAY}</strong>
              </span>
              <i className="fas fa-arrow-right footer-studio__contact-external" aria-hidden="true" />
            </a>
          </section>

          <div className="footer-studio__social">
            <h2>Follow along</h2>
            <p>Discover recent looks, studio updates, and a little beauty inspiration.</p>
            <div className="footer-studio__social-links">
              {socialLinks.map((link) => (
                <a
                  href={link.href}
                  key={link.label}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.label}
                  title={link.label}
                >
                  <i className={link.icon} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="footer-studio__bottom">
          <span>© {new Date().getFullYear()} Arpita’s Makeover</span>
          <span className="footer-studio__signature">
            Made for life’s special moments <i className="fas fa-heart" aria-hidden="true" />
          </span>
        </div>
      </div>
    </footer>
  );
}
